import { ToolOutlined } from '@ant-design/icons'
import { Program } from '@models/membership/Program'
import MuxPlayer from '@mux/mux-player-react'
import { useAppSelector } from '@store/hooks'
import { selectProgramById } from '@store/membership/ProgramReducer'
import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import { Button, Card, Segmented, Space, Typography } from 'antd'
import { FC, useState } from 'react'
import { SBMuxUploader } from './SBMuxUploader'

const { Text } = Typography

type Props = SBModelComponent<Program> & {}

type SegmentedStateType = 'Upload' | 'Preview'

const ProgramVideo: FC<Props> = ({ id, model }) => {
  const item = model ?? useAppSelector(selectProgramById(id!))

  const [isProcessing, setIsProcessing] = useState<boolean>(
    !!item?.videoPassthrough
  )
  const [segmentedState, setSegmentedState] =
    useState<SegmentedStateType>('Preview')

  if (!item) {
    return <></>
  }

  if (isProcessing) {
    return (
      <Card>
        <Space
          orientation="vertical"
          style={{ width: '100%', textAlign: 'center' }}
        >
          <ToolOutlined style={{ fontSize: 40 }} />
          <Text>Is processing</Text>
          <Text type="secondary">
            The video is currently being processed, please wait...
          </Text>
          <Button onClick={() => window.location.reload()}>Refresh</Button>
        </Space>
      </Card>
    )
  }

  return (
    <>
      <Segmented<SegmentedStateType>
        options={['Upload', 'Preview']}
        value={segmentedState}
        onChange={setSegmentedState}
        block
        style={{ marginBottom: 10 }}
      />

      {segmentedState === 'Upload' && (
        <SBMuxUploader
          id="my-uploader"
          item={item}
          setIsProcessing={setIsProcessing}
        />
      )}

      {segmentedState === 'Preview' && (
        <>
          {item.videoPlaybackId ? (
            <MuxPlayer
              playbackId={item.videoPlaybackId}
              accentColor={item.primaryColor}
              style={{ aspectRatio: 16 / 9 }}
            />
          ) : (
            <Text type="secondary">No video uploaded yet</Text>
          )}
        </>
      )}
    </>
  )
}

type ProgramVideoType = { Video: typeof ProgramVideo }

export { ProgramVideo, type ProgramVideoType }
